import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { HomeRoutes } from './home.routes';
import { HomeComponent } from './home.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { ControllerHomeComponent } from './controller-home/controller-home.component';
import { PipesModule } from '@homeleite/common-components';
import { ControllerPageComponent } from './controller-home/controller-page/controller-page.component';
import { ControllersModule } from '../controllers/controllers.module';

@NgModule({
    declarations: [
        HomeComponent,
        AdminHomeComponent,
        ControllerHomeComponent,
        ControllerPageComponent
    ],
    imports: [CommonModule, SharedModule, HomeRoutes, PipesModule, ControllersModule]
})
export class HomeModule {}
